import React from "react";
import { Play, Target, CheckCircle2, Instagram } from "lucide-react";
import { projects } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Projects({ onOpenVideo, onOpenImage }) {
  return (
    <section id="projets" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* header */}
        <Reveal className="text-center mb-16 md:mb-24">
          <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">Portfolio</span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light text-[#3A302A] mt-3">
            Projets <span className="font-script text-[#B0603F] text-4xl md:text-6xl">UGC</span>
          </h2>
          <p className="max-w-xl mx-auto mt-5 font-body text-[#6B5D53]">
            Des collaborations pensées sur-mesure, où chaque marque trouve sa voix à travers un contenu
            sincère et soigné.
          </p>
        </Reveal>

        <div className="space-y-28 md:space-y-40">
          {projects.map((p, i) => {
            const reversed = i % 2 === 1;
            return (
              <Reveal key={p.id}>
                <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
                  {/* gallery */}
                  <div className={`${reversed ? "md:order-2" : ""} `}>
                    <div className="grid grid-cols-2 gap-4">
                      {p.gallery.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => onOpenImage(p.gallery, idx)}
                          className={`hover-zoom rounded-2xl shadow-[0_18px_45px_-22px_rgba(58,48,42,0.45)] ${
                            idx === 0 ? "col-span-2 aspect-[16/10]" : "aspect-[3/4]"
                          }`}
                        >
                          <img src={img} alt={`${p.title} ${idx}`} className="w-full h-full object-cover" />
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* text */}
                  <div className={`${reversed ? "md:order-1" : ""}`}>
                    <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">
                      {p.category} · {p.place}
                    </span>
                    <h3 className="font-serif-display text-4xl md:text-5xl text-[#3A302A] mt-2 mb-6">
                      {p.title}
                    </h3>

                    <div className="mb-6">
                      <div className="flex items-center gap-2 mb-2 text-[#B0603F]">
                        <Target size={18} />
                        <span className="font-body text-sm tracking-wide-2 uppercase">Mission</span>
                      </div>
                      <p className="font-body text-[#6B5D53] leading-relaxed">{p.mission}</p>
                    </div>

                    <div className="mb-8">
                      <div className="flex items-center gap-2 mb-3 text-[#B0603F]">
                        <CheckCircle2 size={18} />
                        <span className="font-body text-sm tracking-wide-2 uppercase">Objectifs</span>
                      </div>
                      <ul className="space-y-2.5">
                        {p.objectives.map((o, k) => (
                          <li key={k} className="flex gap-3 font-body text-[#3A302A]">
                            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#B0603F] shrink-0" />
                            <span>{o}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="flex flex-wrap items-center gap-3">
                      <button
                        onClick={() => onOpenVideo(p)}
                        className="group inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#3A302A] text-[#FAF5EF] text-sm tracking-wide-2 uppercase hover:bg-[#B0603F] transition-colors duration-300"
                      >
                        <span className="w-8 h-8 rounded-full bg-[#FAF5EF]/15 flex items-center justify-center group-hover:scale-110 transition-transform">
                          <Play size={14} fill="currentColor" />
                        </span>
                        Voir la vidéo UGC
                      </button>
                      {p.instagram && (
                        <a
                          href={p.instagram}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#B79A80] text-[#3A302A] text-sm tracking-wide-2 uppercase hover:border-[#B0603F] hover:text-[#B0603F] transition-colors duration-300"
                        >
                          <Instagram size={16} />
                          Instagram
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
